type PaginationItem =
  | { type: "page"; pageNumber: number }
  | { type: "ellipsis-left" }
  | { type: "ellipsis-right" };

export const createPaginationRange = (
  currentPage: number,
  totalPages: number,
  middleCount = 3,
): PaginationItem[] => {
  if (totalPages <= middleCount + 2) {
    return Array.from({ length: totalPages }, (_, i) => ({
      type: "page",
      pageNumber: i + 1,
    }));
  }

  const items: PaginationItem[] = [];

  items.push({ type: "page", pageNumber: 1 });

  let left = Math.max(currentPage - Math.floor(middleCount / 2), 2);
  let right = left + (middleCount - 1);

  if (right > totalPages - 1) {
    right = totalPages - 1;
    left = right - (middleCount - 1);
  }

  if (left > 2) {
    items.push({ type: "ellipsis-left" });
  }

  for (let page = left; page <= right; page++) {
    items.push({ type: "page", pageNumber: page });
  }

  if (right < totalPages - 1) {
    items.push({ type: "ellipsis-right" });
  }

  items.push({ type: "page", pageNumber: totalPages });

  return items;
};
